import { FCM_USE_DONATION_LANGUAGE } from '@change/config/fcm/configs';

import { createFcmHook } from 'src/app/shared/hooks/fcm';

export const useDonationLanguage = createFcmHook({
	enabled: FCM_USE_DONATION_LANGUAGE,
});
